import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { appendStoredAttribution } from '../lib/attributionMemory';
import { useLang } from '../i18n';

const PATIENT_PREFIXES = [
  '/',
  '/hopefirst',
  '/clinical-trials',
  '/conditions',
  '/trial-resources',
  '/patients',
  '/patient-registration',
  '/patient-login',
  '/patient-dashboard',
  '/patient-messaging',
  '/document-upload-hub',
  '/upload',
  '/trial-matching-results',
  '/match-now',
  '/about-us-contact-us',
  '/privacy-policy',
  '/terms',
  '/case-status',
  '/track',
];

export function isPatientMobileRoute(pathname = '') {
  if (pathname === '/') return true;
  return PATIENT_PREFIXES.some((prefix) => prefix !== '/' && (pathname === prefix || pathname.startsWith(`${prefix}/`)));
}

export function stickyCtaHref(pathname = '') {
  if (pathname.startsWith('/patient-registration') || pathname.startsWith('/document-upload') || pathname.startsWith('/upload')) {
    return null;
  }
  return appendStoredAttribution('/hopefirst?tab=find');
}

const PatientStickyCta = () => {
  const { pathname } = useLocation();
  const { t } = useLang();
  const show = isPatientMobileRoute(pathname);
  useEffect(() => {
    if (!show) return undefined;
    document.body.classList.add('patient-mobile-pad');
    return () => document.body.classList.remove('patient-mobile-pad');
  }, [show]);
  if (!show) return null;
  const href = stickyCtaHref(pathname);
  const label = href ? 'Find my trial / Get started' : 'Get started';

  const className = 'flex items-center justify-center min-h-11 w-full rounded-2xl text-white text-sm font-bold shadow-lg px-3';
  const style = { background: 'linear-gradient(135deg, #C2185B, #7B1FA2)' };

  return (
    <div
      className="md:hidden fixed z-40"
      style={{
        left: 'max(12px, env(safe-area-inset-left))',
        right: 'calc(max(12px, env(safe-area-inset-right)) + 60px)',
        bottom: 'max(10px, env(safe-area-inset-bottom))',
      }}
    >
      {href ? (
        <a href={href} data-testid="patient-sticky-cta" className={className} style={style}>
          {t(label)}
        </a>
      ) : (
        <a href="#main-content" data-testid="patient-sticky-cta" className={className} style={style}>
          {t(label)}
        </a>
      )}
    </div>
  );
};

export default PatientStickyCta;
